module.exports = __webpack_public_path__ + "bea18dd7eeaed1e0fa90dcd58dda68df.svg";